module.exports = __webpack_public_path__ + "img/how_to_read_paper.5dc94dc2.jpg";